// extracted by mini-css-extract-plugin
module.exports = {"modal":"deactivate-community-modal_modal__2BHAc","actions":"deactivate-community-modal_actions__2O3b5","message":"deactivate-community-modal_message__wHY_z"};